import * as React from 'react';
import { DefaultButton, Icon, IDropdownOption, IPanelStyles, ITextStyles, Label, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, Text } from '@fluentui/react';

import { useEffect, useState } from 'react';
import { IField, IFascicolo, ITextField, IChoiceField, ITitolario } from '../../shared/interfaces';
import DynamicForm from '../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import AppUtilities from '../../shared/Utilities/appUtilities';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import FilingPlanTree from '../FilingPlan/FilingPlanTree';
import { Fascicolo_Type, Fascicolo_Type_Label } from '../../shared/enums';


const textStyles: Partial<ITextStyles> = {
    root: {
        display: 'block',
        marginTop: '18px'
    }
}

const initialFields: IField[] = [
    {
        displayName: "Tipo fascicolo",
        internalName: "tipoFascicolo",
        controlType: "dropdown",
        sharepointType: "Choice",
        required: true,
        readonly: true,
        disabled: false,
        system: false,
        internalValue: { text: Fascicolo_Type_Label.get(Fascicolo_Type.Undefined) },
        valid: false,
        touched: false,
        options: [
            { text: Fascicolo_Type_Label.get(Fascicolo_Type.Affare), key: Fascicolo_Type.Affare },
            { text: "Attivit\u00e0 ", key: Fascicolo_Type.Attivita },
            { text: Fascicolo_Type_Label.get(Fascicolo_Type.Procedimento), key: Fascicolo_Type.Procedimento },
            { text: Fascicolo_Type_Label.get(Fascicolo_Type.PersonaFisica), key: Fascicolo_Type.PersonaFisica },
            { text: Fascicolo_Type_Label.get(Fascicolo_Type.PersonaGiuridica), key: Fascicolo_Type.PersonaGiuridica }
        ] as IDropdownOption[]
    } as IChoiceField,
    {
        displayName: "Responsabile",
        internalName: "responsabile",
        controlType: "textbox",
        sharepointType: "Text",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    } as ITextField,
    {
        displayName: "Descrizione",
        internalName: "descrizione",
        controlType: "textbox",
        sharepointType: "Text",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    } as ITextField,



];

export interface AddEditFascicoloNodeProps {
    loading?: boolean
    extraCssClass?: string
    selectedFascicoloNode?: IFascicolo
    panelHeaderText: string
    panelIsOpen: boolean
    panelIsEdit: boolean,
    onSubmit: (fascicoloItem: Partial<IFascicolo>) => void
    onDismiss: () => void
}


const AddEditFascicoloNode: React.FunctionComponent<AddEditFascicoloNodeProps> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);
    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');
    const [fields, setFields] = useState<IField[]>([]);
    const [selectedFilinPlanKey, setSelectedFilingPlanKey] = useState<string>();
    const [selectedFilinPlan, setSelectedFilingPlan] = useState<ITitolario>();
    const [titolarioReadonly, setTitolarioReadonly] = useState<boolean>(false);
    const [titolarioTouched, setTitolarioTouched] = useState<boolean>();
    const [titolarioRequired, setTitolarioRequired] = useState<boolean>(true);
    const [titolarioValid, setTitolarioValid] = useState<boolean>();


    useEffect(() => {
        setPanelIsOpen(props.panelIsOpen);
        dismissMessageBar();
        onDismiss();
    }, [props.panelIsOpen]);

    useEffect(() => {
        if (props.panelIsOpen) {
            setFieldsValues();
        }


    }, [props.panelIsEdit, props.selectedFascicoloNode, props.panelIsOpen]);

    const setFieldsValues = () => {
        let currentFascicolo: Partial<IFascicolo> | undefined = undefined;

        let isCreateMode = !props.panelIsEdit;
        if (isCreateMode) {
            /// CREAZIONE DI UN FASCICOLO
            if (props.selectedFascicoloNode) {
                /// CREAZIONE DI UN SOTTO-FASCICOLO
                let parentFascicolo: IFascicolo = { ...props.selectedFascicoloNode! };
                currentFascicolo = {
                    tipoFascicolo: parentFascicolo.tipoFascicolo,
                    titolarioFullIndex: parentFascicolo.titolarioFullIndex,
                    titolarioLabelIndexKey: parentFascicolo.titolarioLabelIndexKey,
                    titolarioId: parentFascicolo.titolarioId
                };

            }
            else {
                /// CREAZIONE DI UN FASCICOLO NELLA ROOT
                currentFascicolo = undefined;
            }

        }
        else {
            /// EDIT DI UN FASCICOLO
            currentFascicolo = { ...props.selectedFascicoloNode! };

        }
        let newFields: IField[] = initialFields.map(el => {
            let _readOnly = el.readonly;
            if (isCreateMode && (!currentFascicolo || el.internalName !== "tipoFascicolo")) {
                _readOnly = false;
            }

            let internalValue = currentFascicolo?.[el.internalName];
            //if (el.internalName == "tipoFascicolo") {
            //    if (internalValue == Fascicolo_Type.Attivita) {
            //        internalValue = "Attivit\u00e0"
            //    }
            //    else {
            //        internalValue = Fascicolo_Type_Label.get(internalValue)
            //    }

            //}

            return {
                ...el, internalValue, readonly: _readOnly
            };

        });
        setTitolarioReadonly(isCreateMode && !currentFascicolo)
        setFields(newFields);
        setSelectedFilingPlanKey(currentFascicolo?.titolarioLabelIndexKey);
        setSelectedFilingPlan({
            id: currentFascicolo?.titolarioId,
            labelIndexKey: currentFascicolo?.titolarioLabelIndexKey,
            fullIndex: currentFascicolo?.titolarioFullIndex
        })
        let titolarioReadonly = !isCreateMode || isCreateMode && currentFascicolo !== undefined;
        setTitolarioReadonly(titolarioReadonly);
        setTitolarioRequired(!titolarioReadonly);
    }


    // Click su salva del panel laterale
    const addEditFascicoloSubmit = () => {
        if (checkFascicoloFormValidity()) {

            let fascicoloItem: Partial<IFascicolo> = {
                tipoFascicolo: fields.find(el => el.internalName === 'tipoFascicolo')?.internalValue,
                descrizione: fields.find(el => el.internalName === 'descrizione')?.internalValue,
                responsabile: fields.find(el => el.internalName === 'responsabile')?.internalValue,
                titolarioId: selectedFilinPlan?.id,
                titolarioLabelIndexKey: selectedFilinPlan?.labelIndexKey,
                titolarioFullIndex: selectedFilinPlan?.fullIndex
            };

            if (!props.panelIsEdit) {
                let newFascicoloItem: Partial<IFascicolo> = {
                    ...fascicoloItem,
                    parentId: props.selectedFascicoloNode?.id
                }
                props.onSubmit(newFascicoloItem);
                resetFormFields();

            } else {
                let editFascicoloItem: Partial<IFascicolo> = {
                    ...fascicoloItem,
                    id: props.selectedFascicoloNode?.id!
                }
                props.onSubmit(editFascicoloItem);
                resetFormFields();
            }
        }
    }

    const resetFormFields = () => {

        let newFields = fields.map(el => {
            return { ...el, internalValue: null, touched: false, valid: true };
        });
        setFields(newFields);
    }

    const checkFascicoloFormValidity = (): boolean => {

        let isValid = true;

        const updatedFields = fields.map((item, index) => {
            let fieldValidity = AppUtilities.checkFieldValidity(item);
            if (!fieldValidity)
                isValid = false;

            return {
                ...item,
                touched: true,
                valid: fieldValidity
            }
        });


        let titolarioValidity = AppUtilities.checkTitolarioFieldValidity(titolarioRequired!, selectedFilinPlanKey)

        if (!titolarioValidity) {
            isValid = false;
        }

        setFields(updatedFields);
        if (isValid) {
            dismissMessageBar();
        }
        else {
            setTitolarioTouched(true);
            setTitolarioValid(titolarioValidity);
            setMessageBarText('Compilare correttamente i campi');
            setMessageBarType(MessageBarType.error);
            showMessageBar();
        }

        return isValid;
    }


    const inputChangedHandler = (newField: IField) => {

        const updatedFields = [...fields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);
        updatedFields[itemIndex] = { ...newField };

        setFields(updatedFields);
    }

    const onDismiss = () => {
        resetFormFields();
    }

    const onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Salva"
                    onClick={addEditFascicoloSubmit}

                />
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }

    const onSelectedFilingPlanKeyHandler = (titolarioKey: string | undefined) => {
        setSelectedFilingPlanKey(titolarioKey);
    }

    const onSelectedFilingPlanHandler = (titolario: ITitolario | undefined) => {
        setSelectedFilingPlan(titolario);
    }

    return (
        <React.Fragment>

            <Panel
                key='addEditFascicoloNode'

                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
                onRenderFooterContent={onRenderLateralPanelFooterContent}
                // Stretch panel content to fill the available height so the footer is positioned
                // at the bottom of the page
                isFooterAtBottom={false}
            >
                {messageBarIsVisible &&
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={false}
                        onDismiss={dismissMessageBar}
                        dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                }

                <CircleLoader loaderClass='loader-large' loading={loading} />

                <div className={"flex flex-column position-relative overflow-hidden"}>

                    <div className={`position-relative my-scroll-div`}>

                        <DynamicForm
                            fields={fields}
                            onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                        />
                        <div className={titolarioTouched && !titolarioValid ? 'titolario field error' : 'titolario field'} >
                            <Label className='field-label' htmlFor={"Titolario"} required={titolarioRequired}>Titolario</Label>
                            {titolarioTouched && !titolarioValid && <span className="error-message">Campo obbligatorio</span>}
                            <FilingPlanTree
                                key={"Titolario"}
                                readOnlyMode={titolarioReadonly}
                                selectedFilingPlanKey={selectedFilinPlanKey}
                                onSelectFilingPlanKeyHandler={onSelectedFilingPlanKeyHandler}
                                onSelectFilingPlanHandler={onSelectedFilingPlanHandler}
                            />
                        </div>
                    </div>
                </div>



                {props.selectedFascicoloNode && !props.panelIsEdit &&
                    <Text variant={'mediumPlus'} styles={textStyles}>Stai creando il nuovo fascicolo sotto "{props.selectedFascicoloNode.fascicoloLabel}"</Text>}
            </Panel>



        </React.Fragment>


    );

}

export default AddEditFascicoloNode;
